import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "edit" }
const _hoisted_2 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Uploadimg = _resolveComponent("Uploadimg")!
  const _component_Uploadfile = _resolveComponent("Uploadfile")!
  const _component_Uploadvideo = _resolveComponent("Uploadvideo")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.show,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.show) = $event)),
      onClose: _ctx.close,
      title: _ctx.isEdit ? '编辑留言' : '新增留言',
      center: "",
      width: "50%",
      "before-close": _ctx.handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, { onClick: _ctx.close }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submitForm
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("提交", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", null, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "ruleFormRef",
              model: _ctx.ruleForm,
              rules: _ctx.rules,
              "label-width": "120px",
              class: "demo-ruleForm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "标题",
                  prop: "title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.title,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.title) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "留言类型",
                  prop: "contentType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.ruleForm.contentType,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.contentType) = $event)),
                      placeholder: "请选择",
                      onChange: _ctx.selectChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageType, (v, k) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: v.enumName,
                            value: k,
                            key: k
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "封面",
                  prop: "fileId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Uploadimg, {
                      image: _ctx.ruleForm.fileUrl,
                      onOnSuccess: _ctx.onSuccess
                    }, null, 8, ["image", "onOnSuccess"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户单位Logo",
                  prop: "orgLogo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Uploadimg, {
                      image: _ctx.ruleForm.orgLogoName,
                      onOnSuccess: _ctx.orgSuccess
                    }, null, 8, ["image", "onOnSuccess"])
                  ]),
                  _: 1
                }),
                (_ctx.ruleForm.contentType=='MESSAGE_LETTER')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "感谢信",
                      prop: "content"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Uploadimg, {
                          image: _ctx.ruleForm.content,
                          onOnSuccess: _ctx.xinSuccess
                        }, null, 8, ["image", "onOnSuccess"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.ruleForm.contentType=='MESSAGE_AUDIO')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "语音",
                      prop: "content"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Uploadfile, {
                          onOnSuccess: _ctx.fileSuccess,
                          multiple: false,
                          files: _ctx.ruleForm.content?[{fileName:_ctx.ruleForm.content,fileRealName:_ctx.ruleForm.content}]:''
                        }, null, 8, ["onOnSuccess", "files"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.ruleForm.contentType=='MESSAGE_VIDEO')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: "视频",
                      prop: "content"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Uploadvideo, {
                          onOnSuccess: _ctx.fileSuccess,
                          files: _ctx.ruleForm.content
                        }, null, 8, ["onOnSuccess", "files"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose", "title", "before-close"])
  ]))
}